


document.addEventListener('DOMContentLoaded', () => {
    // Mobile grid buttons
    const mblButtons = document.querySelectorAll('.mbl-grid-btn .two-row-btn, .mbl-grid-btn .one-row-btn');
    mblButtons.forEach(button => {
      button.addEventListener('click', () => {
        mblButtons.forEach(btn => btn.classList.remove('is-active'));
        button.classList.add('is-active');
        const productGrid = document.querySelector('.product-grid');
        if (button.value === 'medium') {
          productGrid.classList.add('grid-medium');
        } else {
          productGrid.classList.remove('grid-medium');
        }
      });
    });

    // Desktop grid buttons
    const dskButtons = document.querySelectorAll('.dsk-grid-btn .two-row-btn, .dsk-grid-btn .one-row-btn');
    dskButtons.forEach(button => {
      button.addEventListener('click', () => {
        dskButtons.forEach(btn => btn.classList.remove('is-active'));
        button.classList.add('is-active');
        const productGrid = document.querySelector('.product-grid');
        if (button.value === 'medium') {
          productGrid.classList.add('grid-medium');
        } else {
          productGrid.classList.remove('grid-medium');
        }
      });
    });
  });


// function handleRemoveButtonClick(event) {
//   // Prevent default action and stop event propagation
//   event.preventDefault();
//   event.stopPropagation();

//   // Store the reference to the clicked button
//   var clickedButton = $(this);
//   var clickedCartItem = clickedButton.closest('.cart-item');
//   var clickedCartItemName = clickedCartItem.find('.cart-item__name').text().trim();
//   var clickedVariantId = clickedCartItem.attr('data-variant-id');  // Get the clicked variant ID

//   console.log('Clicked cart item name (without Price Adjustment): ' + clickedCartItemName);

//   // Array to store all matched variant IDs (including the clicked one)
//   var matchedVariantIds = [];

//   // Loop through all cart items and match titles
//   $('.cart-item').each(function() {
//     var otherCartItemName = $(this).find('.cart-item__name').text().replace(/Price Adjustment/g, '').trim();
//     var otherVariantId = $(this).attr('data-variant-id');  // Get the variant ID of the current item

//     // If the product name matches the clicked product's name, store its variant ID
//     if (otherCartItemName === clickedCartItemName) {
//       matchedVariantIds.push(otherVariantId);  // Add the matching product's variant ID
//       console.log('Matching cart item found with variant ID: ' + otherVariantId);
//     }
//   });

//   console.log('Match Found: ' + matchedVariantIds);

//   // Check if there are matched variants (including the clicked one)
//   if (matchedVariantIds.length > 0) {
//     console.log('Matched variants to remove:', matchedVariantIds);

//     // Run a single AJAX request to remove all matched variants from the cart
//     $.ajax({
//       url: '/cart/update.js',  // Shopify's cart update endpoint
//       method: 'POST',
//       data: {
//         updates: matchedVariantIds.reduce((updates, variantId) => {
//           updates[variantId] = 0;  // Set quantity to 0 for each matched variant
//           return updates;
//         }, {})
//       },
//       dataType: 'json',
//       success: function(response) {
//         console.log('Cart updated successfully:', response);

//         var currentPageUrl = window.location.href;

//         // Make an AJAX request to get the updated page content
//         $.ajax({
//             url: currentPageUrl,
//             type: 'GET',
//             success: function(response) {
//                 // Use DOMParser to parse the response HTML
//                 var parser = new DOMParser();
//                 var doc = parser.parseFromString(response, 'text/html');
    
//                 // Find the specific elements in the parsed document
//                 var updatedItems = doc.querySelector('cart-drawer.drawer').innerHTML;
//                 var updatedCartCount = doc.querySelector('.cart-icon-wrapper .cart-count-bubble > span[aria-hidden="true"]').innerHTML;
    
//                 // Update the existing elements on the page with the updated content
//                 $('cart-drawer.drawer').html(updatedItems);
//                 $('.cart-icon-wrapper .cart-count-bubble > span[aria-hidden="true"]').html(updatedCartCount);
//                 if(doc.querySelector('.cart-icon-wrapper .cart-count-bubble > span[aria-hidden="true"]').innerText == '(0)') {
//                   $('cart-drawer.drawer').addClass('is-empty');
//                 }

//                 setTimeout(function() {
//                   $('cart-remove-button .button').off('click');
//                   $('cart-remove-button .button').on('click', handleRemoveButtonClick);
//                 }, 1500);
               
//             },
//             error: function(xhr, status, error) {
//                 console.error('Error fetching updated cart drawer content:', error);
//             }
//         });

//         // Trigger the remove action on the clicked product after the matched products are removed
//         // clickedButton.off('click').trigger('click');
//       },
//       error: function(error) {
//         console.error('Error updating cart:', error);
//       }
//     });
//   } else {
//     // No matches found, just trigger the remove action for the clicked product
//     clickedButton.off('click').trigger('click');
//   }

//   setTimeout(function() {
//     $('cart-remove-button .button').off('click');
//     $('cart-remove-button .button').on('click', handleRemoveButtonClick);
//   }, 2500);
  
// }


// $(document).ready(function() {

//   if($('body').hasClass('template-product')) {

//       $('.product-form__buttons button[type="submit"]').click(function(event) {
        
//         var checkInputField = $('.input-box-main input[type="text"]').val();
//         var $this = $(this);
//         if(checkInputField != '' && !$(this).hasClass('success')) {
//           console.log('API Script Run');
//           event.preventDefault();
//           $('.load-more').attr('style', 'display: flex;');
//           var getProTitle = $('.product__title h1').text();
//           getProTitle = `${getProTitle}`;
//           var getProImg = $('.main-prod-slider .thumbnail-img .swiper-slide-active .image-wrap img').attr('src');
//           var getProPrice = $('.price__sale .price-item--sale').text();
//           var numericValue = parseFloat(getProPrice.match(/[\d.]+/)[0]);
//           var proPacks = $('.packk-blk .pack-qty').text();
//           var proM = $('.packk-blk .fp-require-area').text();
//           var totalPackPrice = numericValue * proPacks;
//           totalPackPrice = totalPackPrice.toFixed(2);
//           var totalAreaPrice = numericValue * proM;
//           totalAreaPrice = totalAreaPrice.toFixed(2);
//           // var finalPrice = totalAreaPrice - totalPackPrice;
//           var finalPrice = totalAreaPrice;
//           // finalPrice = finalPrice.toFixed(2);

//           var data = {
//               title: getProTitle,
//               price: finalPrice,
//               img: getProImg
//           };
          
//           $.ajax({
//               url: 'https://ukflooringdepot.gearhikes.com/api/custom-api-create-product',
//               method: 'POST',
//               contentType: 'application/json',
//               headers: {
//                   'Authorization': 'Bearer YOUR_ACCESS_TOKEN'
//               },
//               data: JSON.stringify(data)
//           })
//           .done(function(response) {
//               if (response.product_id && response.variant_id) {
//                   console.log('Product created successfully:');
//                   console.log('Product ID:', response.product_id);
//                   console.log('Variant ID:', response.variant_id);

//                   $('.load-more').hide();
//                   $('.product-form:not(.sample-btn) .product-variant-id').val(response.variant_id);
//                   $('.product-form:not(.sample-btn) input[name="properties[Packs]"]').remove();
//                   $('.product-form:not(.sample-btn) form').prepend(`<input type="hidden" name="properties[Packs]" value="${$('.packk-blk .pack-qty').text()}">`);
//                   $('.product-form:not(.sample-btn) #Quantity').val('1');
//                   $this.addClass('success');
//                   $this.click();
//                   Cookies.set('productAPI', 'cookieValue', { expires: 1 });
                
//               } else {
//                   console.log('Product created, but no IDs returned:', response.message);
//               }
//           })
//           .fail(function(jqXHR, textStatus, errorThrown) {
//               console.error('Failed to create product:', textStatus, errorThrown);
//           });
          
//         } else {
//           $this.removeClass('success');
//             // setTimeout(function() {
//             //   $('cart-remove-button .button').on('click', handleRemoveButtonClick);
//             // }, 2500);
//         }
        
//       });
    
//   }

//   $.getJSON('/cart.js', function(cart) {
//       if (cart.item_count === 0) {
//           console.log("The cart is empty.");
//           if (Cookies.get('productAPI')) {
//               console.log('productAPI Cookie exists!');
//               $.ajax({
//                 url: 'https://ukflooringdepot.gearhikes.com/api/custom-api-delete-product-TZ',
//                 method: 'POST',  // Change to POST if necessary
//                 headers: {
//                     'Authorization': 'Bearer YOUR_ACCESS_TOKEN',
//                     'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
//                 },
//                 success: function(response) {
//                     console.log('Success:', response.message);
//                     Cookies.remove('productAPI');
//                 },
//                 error: function(jqXHR, textStatus, errorThrown) {
//                     console.error('Error:', textStatus, errorThrown);
//                 }
//             });
//           } else {
//               console.log('productAPI Cookie does not exist.');
//           }
//       } else {
//           console.log("The cart has items.");
//       }
//   });

  
  
//   // Attach the custom click handler to the remove button
//   // $('cart-remove-button .button').on('click', handleRemoveButtonClick);



  
// });



$(document).ready(function() {
    // Generate unique session ID (lasts 24 hours)
    function getOrCreateSessionId() {
        let sessionId = localStorage.getItem('shopifyUserSessionId');
        let sessionExpiry = localStorage.getItem('sessionExpiry');
        const now = Date.now();
        
        // Create new session if expired or doesn't exist
        if (!sessionId || !sessionExpiry || now > parseInt(sessionExpiry)) {
            sessionId = 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            localStorage.setItem('shopifyUserSessionId', sessionId);
            localStorage.setItem('sessionExpiry', (now + (24 * 60 * 60 * 1000)).toString()); // 24 hours
            
            // Clear old session data
            sessionStorage.removeItem('myProducts');
            console.log('New session created:', sessionId);
        } else {
            console.log('Existing session:', sessionId);
        }
        
        return sessionId;
    }

    const sessionId = getOrCreateSessionId();
    
    // Store my created products
    function getMyProducts() {
        return JSON.parse(sessionStorage.getItem('myProducts') || '[]');
    }
    
    function addMyProduct(productId, variantId) {
        const products = getMyProducts();
        products.push({
            productId: productId,
            variantId: variantId,
            sessionId: sessionId,
            createdAt: new Date().toISOString()
        });
        sessionStorage.setItem('myProducts', JSON.stringify(products));
        console.log('Product added to my list:', productId);
    }
    
    function clearMyProducts() {
        sessionStorage.removeItem('myProducts');
    }

    // Check if my products are in cart
    async function areMyProductsInCart() {
        const myProducts = getMyProducts();
        if (myProducts.length === 0) return false;
        
        try {
            const cart = await $.getJSON('/cart.js');
            const myVariantIds = myProducts.map(p => p.variantId.toString());
            
            return cart.items.some(item => 
                myVariantIds.includes(item.variant_id.toString())
            );
        } catch (error) {
            console.error('Error checking cart:', error);
            return false;
        }
    }

    // Delete only MY session products
    function deleteMySessionProducts() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: 'https://ukflooringdepot.gearhikes.com/api/custom-api-delete-session-products',
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: JSON.stringify({ session_id: sessionId }),
                success: function(response) {
                    console.log('My session products deleted:', response.message);
                    clearMyProducts();
                    resolve(response);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error('Error deleting my products:', textStatus, errorThrown);
                    reject(errorThrown);
                }
            });
        });
    }

    // Main product creation logic
    if($('body').hasClass('template-product')) {
        $('.product-form__buttons button[type="submit"]').click(function(event) {
            var checkInputField = $('.input-box-main input[type="text"]').val();
            var $this = $(this);
            
            if(checkInputField != '' && !$(this).hasClass('success')) {
                console.log('Creating product for session:', sessionId);
                event.preventDefault();
                $('.load-more').attr('style', 'display: flex;');
                
                var getProTitle = $('.product__title h1').text();
                var getProImg = $('.main-prod-slider .thumbnail-img .swiper-slide-active .image-wrap img').attr('src');
                var getProPrice = $('.price__sale .price-item--sale').text();
                var numericValue = parseFloat(getProPrice.match(/[\d.]+/)[0]);
                var proPacks = $('.packk-blk .pack-qty').text();
                var proM = $('.packk-blk .fp-require-area').text();
                var totalAreaPrice = numericValue * proM;
                totalAreaPrice = totalAreaPrice.toFixed(2);

                var data = {
                    title: getProTitle,
                    price: totalAreaPrice,
                    img: getProImg,
                    session_id: sessionId  // ADD SESSION ID
                };
                
                $.ajax({
                    url: 'https://ukflooringdepot.gearhikes.com/api/custom-api-create-product-session',
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(data)
                })
                .done(function(response) {
                    if (response.product_id && response.variant_id) {
                        console.log('Product created for session:', response.session_id);
                        console.log('Product ID:', response.product_id);
                        console.log('Variant ID:', response.variant_id);

                        // Store in my products list
                        addMyProduct(response.product_id, response.variant_id);

                        $('.load-more').hide();
                        $('.product-form:not(.sample-btn) .product-variant-id').val(response.variant_id);
                        $('.product-form:not(.sample-btn) input[name="properties[Packs]"]').remove();
                        $('.product-form:not(.sample-btn) form').prepend(`<input type="hidden" name="properties[Packs]" value="${proPacks}">`);
                        $('.product-form:not(.sample-btn) #Quantity').val('1');
                        $this.addClass('success');
                        $this.click();
                        
                    } else {
                        console.log('Product creation failed:', response.message);
                    }
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    console.error('Failed to create product:', textStatus, errorThrown);
                });
                
            } else {
                $this.removeClass('success');
            }
        });
    }

    // Monitor cart and cleanup
    async function monitorCart() {
        try {
            const cart = await $.getJSON('/cart.js');
            const myProducts = getMyProducts();
            
            if (myProducts.length === 0) {
                return; // No products to track
            }
            
            if (cart.item_count === 0) {
                console.log('Cart empty, checking if I have products to delete...');
                // Cart is empty, delete my session products
                await deleteMySessionProducts();
            } else {
                // Check if MY products are still in cart
                const myVariantIds = myProducts.map(p => p.variantId.toString());
                const cartVariantIds = cart.items.map(item => item.variant_id.toString());
                
                const myProductsInCart = myVariantIds.some(variantId => 
                    cartVariantIds.includes(variantId)
                );
                
                if (!myProductsInCart) {
                    console.log('My products not in cart, deleting them...');
                    await deleteMySessionProducts();
                } else {
                    console.log('My products still in cart, keeping them.');
                }
            }
        } catch (error) {
            console.error('Error monitoring cart:', error);
        }
    }

    // Setup cart change listeners
    function setupCartMonitoring() {
        // Listen for Shopify cart updates
        $(document).on('ajaxComplete', function(event, xhr, settings) {
            if (settings.url && (
                settings.url.includes('/cart/update.js') || 
                settings.url.includes('/cart/change.js') ||
                settings.url.includes('/cart/add.js') ||
                settings.url.includes('/cart/clear.js')
            )) {
                setTimeout(monitorCart, 1000);
            }
        });

        // Check on page load
        $(window).on('load', function() {
            monitorCart();
            
            // Periodic check every 2 minutes
            setInterval(monitorCart, 120000);
        });

        // Check before leaving page
        $(window).on('beforeunload', function() {
            // Quick sync check
            $.ajax({
                url: '/cart.js',
                method: 'GET',
                async: false,
                success: function(cart) {
                    if (cart.item_count === 0) {
                        const myProducts = getMyProducts();
                        if (myProducts.length > 0) {
                            console.log('Page unloading, deleting my products...');
                            $.ajax({
                                url: 'https://ukflooringdepot.gearhikes.com/api/custom-api-delete-session-products',
                                method: 'POST',
                                async: false,
                                contentType: 'application/json',
                                headers: {
                                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                },
                                data: JSON.stringify({ session_id: sessionId })
                            });
                        }
                    }
                }
            });
        });
    }

    // Initialize
    setupCartMonitoring();

    // Initial cart check (replaces your original cookie-based check)
    $.getJSON('/cart.js', function(cart) {
        if (cart.item_count === 0) {
            console.log("Initial cart check: Cart is empty.");
            const myProducts = getMyProducts();
            if (myProducts.length > 0) {
                console.log('I have products but cart is empty, cleaning up...');
                deleteMySessionProducts();
            }
        } else {
            console.log("Initial cart check: Cart has items.");
        }
    });
});